import React from "react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from 'react';
import Form from "react-validation/build/form";
import { Alert } from 'react-bootstrap';
import { useParams } from "react-router-dom";
import APIConfig from "../../../../api/APIConfig";
import AuthService from "../../../../services/auth.service";

import {
    Box,
    Center,
    Button,
    Stack,
    Text,
    VStack,
    useColorModeValue,
    FormControl,
    FormLabel,
    Input,
} from '@chakra-ui/react';

function FormProfilMentor() {
    const navigate = useNavigate();
    const [namaMentor, setNamaMentor] = useState('');
    const [namaPerusahaan, setNamaPerusahaan] = useState('');
    const [currentUser, setCurrentUser] = useState([]);
    const [validation, setValidation] = useState({});
    const { id } = useParams();

    useEffect(() => {
        const user = AuthService.getCurrentUser();
        if (user) {
            setCurrentUser(user);
        }
    }, []);

    useEffect(() => {
        getMentorById();
        
    },[]);
    
    const getMentorById = async() => {
        const response = await APIConfig.get(`/v1/mentor/${id}`);
        const data = await response.data
        setNamaMentor(data.namaMentor);
        setNamaPerusahaan(data.namaPerusahaan);
    };

    const updateProfilMentor = async (e) => {
        e.preventDefault();
        await APIConfig.put(`v1/mentor/${id}`, {
            namaMentor: namaMentor,
            namaPerusahaan: namaPerusahaan
        })
        .then(() => {
            console.log("berhasil") 
            navigate(`/mentor/profile/lihat/${id}`);

        })
        .catch((error) => {
            console.log(error);
            setValidation(error.response.data);
        })
        
    };


    return (
        <Center py={6}>
        <VStack justifyItems='left' fontFamily={'Inter'}>
            <Text
                pt={10}
                paddingBottom={10}
                color={'gray.700'}
                fontWeight={600}
                fontSize={'2xl'}
                letterSpacing={1.1}
                fontFamily={'Inter'}>
                Edit Profil
            </Text>
            <Box
                m='10px'
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                justifyContent='left'
                bg={useColorModeValue('white', 'gray.900')}
                rounded={'2xl'}
                p={6}
                overflow={'hidden'}>
                <VStack 
                spacing={4}
                align='stretch'
                p={3}
                >
                     {
                        validation.errors &&
                            <Alert variant="danger">
                                <ul class="mt-0 mb-0">
                                    { validation.errors.map((error, index) => (
                                        <li key={index}>{ `${error.param} : ${error.msg}` }</li>
                                    )) }
                                </ul>
                            </Alert>
                    }
                    
                    <Form onSubmit={updateProfilMentor}>
                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='namaMentor'>Nama Lengkap</FormLabel>
                        <Input 
                            id='namaMentor' 
                            placeholder='Masukkan nama lengkap'
                            value={namaMentor}
                            onChange={(e) => setNamaMentor(e.target.value)}
                             />
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='email'>Email</FormLabel>
                            <Input 
                            isDisabled 
                            id='email' 
                            placeholder='Masukkan alamat email'
                            value={currentUser.emailUser} />
                        </FormControl>

                        <FormControl pb={6} fontFamily={'Inter'}>
                        <FormLabel htmlFor='perusahaan'>Perusahaan</FormLabel>
                            <Input 
                            isDisabled 
                            id='perusahaan' 
                            variant="filled" 
                            value={namaPerusahaan} />
                        </FormControl>
                        <Stack pt={6} justifyContent='right' direction='row' spacing={4} align='center'>
                            <Button 
                                onClick={() => navigate(-1)}
                                p={6} rounded={'xl'} colorScheme='purple' variant='outline'>
                                Kembali
                            </Button>
                            <Button 
                                type='submit'
                                p={6}
                                loadingText='Submitting'
                                colorScheme='purple' 
                                rounded={'xl'}
                                variant='solid'>
                                Simpan
                            </Button>
                        </Stack>
                    </Form>
                </VStack>
            </Box>
        </VStack>
        </Center>
    );
}

export default FormProfilMentor;